import moment from 'moment';
import { useParams } from 'react-router-dom';
import { IWalletTransactionFilters } from '../types/walletTransaction';
import { defaultWalletTransactionFilters } from '../constants/walletTransactionRow';
import { dateFormatForRequest } from '~/constants/dateTime';

export interface IWTLogColumnsWidth {
  depositDate: number;
  author_name: number;
  object: number;
  transaction_amount: number;
  balance_type: number;
  transaction_type: number;
  reason: number;
  order_number: number;
  expiration_date: number;
  wallet_id: number;
}

const getWTLogColumnsWidth = () => {
  return {
    depositDate: 8,
    author_name: 10,
    object: 12,
    transaction_amount: 10,
    balance_type: 9,
    transaction_type: 10,
    reason: 14,
    order_number: 12,
    expiration_date: 10,
    wallet_id: 5,
  };
};

export const getValidWTLogColumnsWidth = (): IWTLogColumnsWidth => {
  const columnsWidth = getWTLogColumnsWidth();
  const sum = Object.values(columnsWidth).reduce((acc, val) => acc + val, 0);

  if (sum !== 100) {
    throw new Error(`The length of the columns in the sum should give 100%. Current length is ${sum}`);
  }

  return columnsWidth;
};

export const getWTLogColumnsSceleton = (columnsWidth: number): number => {
  return columnsWidth * 12;
};

export const getUserId = (): number | undefined => {
  const { id } = useParams<{ id?: string }>();

  if (id === undefined) {
    return undefined;
  }

  return parseInt(id, 10);
};

export const formatDate = (date: number) => {
  return moment(date * 1000).format(dateFormatForRequest);
};

export const compareFiltersWithDefault = (filter: IWalletTransactionFilters) => {
  if (filter.userId !== defaultWalletTransactionFilters.userId) {
    return false;
  }

  if (filter.startDate !== defaultWalletTransactionFilters.startDate) {
    return false;
  }

  if (filter.endDate !== defaultWalletTransactionFilters.endDate) {
    return false;
  }

  if (filter.balance_type !== defaultWalletTransactionFilters.balance_type) {
    return false;
  }

  if (filter.transaction_type !== defaultWalletTransactionFilters.transaction_type) {
    return false;
  }

  return true;
};
